import emailMixin from '@/mixins/emailMixin';
import config from '@/common/config'; 

export default {
    mixins: [emailMixin],
    methods: {
        $_getEmailMeta(loggedInEmployee, employee, position) {
            const link = `${config.APP_URL}employee/${employee.id}/position/${position.id}`;
            const body = `<p>Here is a link to the ${this.$term('positionDescription', { case: 'title' })} <a href="${link}" target="_blank">${position.title}</a>.</p>${this.$_getEmployeeEmailSignature(loggedInEmployee)}`
            const subject = `${this.$term('positionDescription', { case: 'title' })} - ${position.title}`
            return { subject, body }
        },
        $_getEmailMetaForEmployeeAck(loggedInEmployee, employee, position) {
            const link = `${config.APP_URL}employee/${employee.id}/position/${position.id}`;
            const body = `<p>Hi ${employee.firstName},</p><p>Please read through and acknowledge your ${this.$term('positionDescription')} for <a href="${link}" target="_blank">${position.title}</a>.</p><p style="font-style: italic">This position description outlines the main duties however other tasks may be assigned at the discretion of the organisation. You are required to be familiar with the content of this position description and make all reasonable efforts to follow it.</p>${this.$_getEmployeeEmailSignature(loggedInEmployee)}`
            const subject = `${this.$term('positionDescription', { case: 'title' })} - ${position.title}`
            return { subject, body }
        },
        $_getEmailMetaAfterPositionApproval(loggedInEmployee, employee, position, requireEmployeeAcknowledgement) {
            if (requireEmployeeAcknowledgement) {
                return this.$_getEmailMetaForEmployeeAck(loggedInEmployee, employee, position);
            }

            const link = `${config.APP_URL}employee/${employee.id}/position/${position.id}`;
            const body = `<p>Hi ${employee.firstName},</p><p>Your ${this.$term('positionDescription')} for <a href="${link}" target="_blank">${position.title}</a> has been approved and is now live. Please take the time to read through it.</p>${this.$_getEmployeeEmailSignature(loggedInEmployee)}`;
            const subject = `${this.$term('positionDescription', { case: 'title' })} - ${position.title}`;
            return { subject, body };
        },
        $_getPositionDescriptionLink(employee, position) {
            return `${config.APP_URL}employee/${employee.id}/position/${position.id}`;
        }
    }
}
